import "./LanguageSwitch.scss";

import { Grid, Switch } from "@material-ui/core";
import { StoreState } from "common/store/types";
import { LANGUAGE_ACTION } from "common/store/user/actions";
import React, { useEffect } from "react";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export const LanguageSwitch = ({ onLanguageChanged }: any) => {
  // Hooks
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector<StoreState, string>((state) => state.language);

  // Options
  const handleChange = (event: any) => {
    const isDe = event.target.checked;
    let newLanguage;
    if (isDe) {
      newLanguage = "de";
    } else {
      newLanguage = "en";
    }

    i18n.changeLanguage(newLanguage);

    dispatch({
      type: LANGUAGE_ACTION,
      payload: newLanguage,
    });

    if (onLanguageChanged) {
      onLanguageChanged(newLanguage);
    }
  };

  // Actions
  useEffect(
    () => {
      if (language !== i18n.language) {
        i18n.changeLanguage(language);
      }
    },
    [language, i18n.language]
  );

  const getOppositeCountryCode = (lang: string) => {
    switch (lang) {
      case "en":
        return "DE";
      case "de":
        return "GB";
      default:
        return "DE";
    }
  };

  return (
    <Grid
      component="label"
      container
      alignItems="center"
      spacing={0}
      justify="flex-end"
      className="language-switch"
    >
      <ReactCountryFlag
        svg
        countryCode={getOppositeCountryCode(language)}
        className="flag"
      />

      <Grid item>
        <Switch
          size="small"
          checked={language === "de"}
          color="default"
          inputProps={{ "aria-label": "checkbox with default color" }}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};
